import { useState, useEffect, useRef } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { sortTableRows } from "./utils/tableSort";
import { config } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const Subcategory = () => {
  const [ subcategories, setSubcategories ] = useState(null);
  const [ tableSearch, setTableSearch ] = useState('');
  const [ tableSortBy, setTableSortBy ] = useState('product_subcategory_name');
  const [ tableSortType, setTableSortType ] = useState('ascending');
  const [ isLoadingPage, setIsLoadingPage ] = useState(true);
  const searchInputRef = useRef(null);

  useEffect(() => {
    getSubcategories();
  }, []);

  const getSubcategories = async () => {
    try {
      const requestSubcategories = {};
      const fetchSubcategories = await jwtFetch(config.ENDPOINT + 'get/product_subcategory', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestSubcategories)
      });
      const responseSubcategories = await fetchSubcategories.json();
      if (responseSubcategories.status === 200) {
        for (let i in responseSubcategories.data) {
          let searchData = String(responseSubcategories.data[i].product_subcategory_name ?? '').toLowerCase() + " ";
          responseSubcategories.data[i].search = searchData;
        }
        setSubcategories(responseSubcategories.data);
        setIsLoadingPage(false);
      } else {
        alert(responseSubcategories.message);
      }
    } catch (error) {
      console.error('Error in getSubcategories:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const sortTable = (sortBy) => {
    if (tableSortBy === sortBy) {
      setTableSortType(tableSortType === 'ascending' ? 'descending' : 'ascending');
    } else {
      setTableSortBy(sortBy);
      setTableSortType('ascending');
    }
  }

  const clearSearch = () => {
    setTableSearch('');
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }

  return (
    <div id="subcategory-list">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="product"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center justify-content-between gap-4">
                      <div className="fs-24">Product List</div>
                      <div className="btn-group" role="group">
                        <button className="btn btn-secondary" type="button" onClick={() => window.location.href = '/product'}><i className="bi bi-box me-1"/> Products</button>
                        <button className="btn btn-secondary" type="button" onClick={() => window.location.href = '/product/category'}><i className="bi bi-tag me-1"/> Categories</button>
                        <button className="btn bg-gold" type="button"><i className="bi bi-tags me-1"/> Subcategories</button>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="input-group input-search">
                        <button className="btn bg-white" type="button" onClick={() => clearSearch()}>{tableSearch ? <i className="bi bi-x-lg"/> : <i className="bi bi-search"/>}</button>
                        <input className="form-control" type="text" placeholder="Search" value={tableSearch} onChange={(e) => setTableSearch(e.target.value)} ref={searchInputRef} autoFocus/>
                      </div>
                      <button className="btn btn-link bg-gold" type="button" onClick={() => window.location.href = '/product/category/subcategory/add'}><i className="bi bi-plus-circle me-1"/> Add</button>
                    </div>
                  </div>
                  <div className="bg-white border-radius-4 p-4">
                    {subcategories && subcategories.length ? (
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th className="bg-gold">#</th>
                              <th className="bg-gold pointer" onClick={() => sortTable('product_subcategory_name')}>Name {tableSortBy === 'product_subcategory_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th>
                              <th className="bg-gold pointer text-center" onClick={() => sortTable('category_name')}>Category {tableSortBy === 'category_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th>
                              <th className="bg-gold pointer text-center" onClick={() => sortTable('products')}>Products {tableSortBy === 'products' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th>
                              <th className="bg-gold pointer text-center" onClick={() => sortTable('product_subcategory_status')}>Status {tableSortBy === 'product_subcategory_status' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th>
                              <th className="bg-gold"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortTableRows(subcategories, tableSortBy, tableSortType === 'ascending')
                            .filter(subcategory => (subcategory.search || '').includes((tableSearch || '').trim().toLowerCase()))
                            .map((subcategory, c) => 
                              <tr key={"subcategory-" + c}>
                                <td valign="middle">{c + 1}</td>
                                <td valign="middle">{subcategory.product_subcategory_name}</td>
                                <td valign="middle" align="center">{subcategory.category_name}</td>
                                <td valign="middle" align="center">{subcategory.products}</td>
                                <td valign="middle" align="center"><span className={"badge bg-" + (subcategory.product_subcategory_status === 'Active' ? 'success' : 'danger')}>{subcategory.product_subcategory_status}</span></td>
                                <td valign="middle" align="right"><button className="btn btn-sm bg-gold" onClick={() => window.location.href = '/product/category/subcategory/detail/' + subcategory.id_product_subcategory}><i className="bi bi-eye"/></button></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>{isLoadingPage ? 'Loading...' : 'No data'}</p>
                    )}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subcategory;


